import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["canvas", "label", "input"]

  connect() {
    this.setupElements()
    this.setupChemdoodle()
  }

  setupElements() {
    // alpaca is just going to give us a label and a hidden input field
    // we have to create a canvas element ourselves
    this.element.classList.add("d-flex", "flex-column", "gap-2")
    this.alpacaId = this.element.dataset.alpacaFieldId
    let canvas = this.element.querySelector("canvas")
    if (!canvas) {
      canvas = document.createElement("canvas")
      canvas.dataset.dynamicFormChemdoodleTarget = "canvas"
      this.element.appendChild(canvas)
    }
    canvas.id = `chemdoodle-${this.alpacaId}`
  }

  setupChemdoodle() {
    const cd = new ChemDoodle.SketcherCanvas(this.canvasTarget.id, 600, 300, { oneMolecule: true, useServices: false })
    this.cd = cd
    cd.toolbarManager.buttonSave.getElement().style.display = 'none'; // remove save button from toolbar
    cd.toolbarManager.buttonOpen.getElement().style.display = 'none'; // remove open file button from toolbar
    cd.toolbarManager.buttonTemplate.getElement().style.display = 'none'; // remove molecule template button from toolbar

    // load existing molefile when editing
    const molefile = this.inputTarget.value
    if (molefile.includes("Molecule from ChemDoodle Web Components")) {
      cd.loadMolecule(ChemDoodle.readMOL(molefile))
    }

    // Listening to changes in the editor
    // writing molecule to input field
    cd.oldFunc = cd.checksOnAction
    const controller = this
    cd.checksOnAction = function(force){
      this.oldFunc(force);
      const mol = cd.getMolecule();
      controller.inputTarget.value = ChemDoodle.writeMOL(mol);
    }
  }
}
